import React from "react";

export default function ChatOptionsMenu({
  onResendInvite,
  onReEstablishConnection,
  showReconnect,
  onClose,
  menuRef,
}) {
  return (
    <div
      style={styles.menuPopup}
    ref={menuRef}>
      {(
        <div
          style={styles.menuItemStyle}
          onClick={() => {
            onResendInvite();
            onClose();
          }}
        >
          (Re)send Chat Invitation
        </div>
      )}

      {showReconnect && (
        <div
          style={styles.menuItemStyle}
          onClick={() => {
            onReEstablishConnection();
            onClose();
          }}
        >
          Update Encryption Keys
        </div>
      )}
    </div>
  );
}

const styles = {
  menuItemStyle: {
    padding: "0.75rem 1rem",
    cursor: "pointer",
    color: "#fff",
    fontSize: "0.95rem",
    borderBottom: "1px solid #222",
  },
  menuPopup: {
    position: "absolute",
    right: 0,
    top: "2.5rem",
    backgroundColor: "#222",
    border: "1px solid #444",
    borderRadius: "8px",
    padding: "1rem",
    zIndex: 99,
    minWidth: "200px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
    textAlign: "left",
  },
}

  